import { SchemaTransformerArgs } from '@web-config-app/core';
import jsonLogic from 'json-logic-js';
import { getConditionOfType } from '../get-condition-of-type/get-condition-of-type';

/**
 * This function handles the `requiredIf` type of `x-entity-conditional` annotation.
 * If the condition evaluates to true, its propertyName will be added to the required array of its parent.
 *
 * @param schema - the current schema slice
 * @param data - the form data
 * @param options - schema transformer options
 * @returns if the condition is met or not
 */
export const evaluateRequiredIfCondition = ({
  schema,
  data,
  options,
}: SchemaTransformerArgs) => {
  const requiredIdCondition = getConditionOfType(schema, 'requiredIf');

  if (!requiredIdCondition) return undefined;

  // Merge rootData under `$` key to support `$.path` references in JsonLogic var operator
  const dataToEvaluate = {
    ...data,
    ...(options?.rootData !== undefined && { $: options.rootData }),
    ...(options?.featureFlags !== undefined && {
      _featureFlags: options.featureFlags,
    }),
  };

  return jsonLogic.apply(requiredIdCondition.rules, dataToEvaluate);
};
